<template>
  <Error404 v-if="!debugMode" />
  <div v-else class="main-dashboard-panel program-details-page">
    <div class="panel-topnav container-fluid">
      <div class="clearfix"></div>
    </div>

    <div class="container-fluid">
      <h3>Sample</h3>

      <UserContext>
        <UserDetails />
        <UserDetails />
      </UserContext>
    </div>
  </div>
</template>

<script>
import UserContext from './UserContext.vue'
import UserDetails from './UserDetails'
import Error404 from '@/modules/errors/Error404'

export default {
  components: {
    Error404,
    UserContext,
    UserDetails,
  },
  setup() {
    const debugMode = process.env.NODE_ENV !== 'production'
    return {
      debugMode,
    }
  },
}
</script>
